




















































import { helpers, required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
    name: 'ScheduleJobPublicationModal',

    setup(props, context) {
        const { $dayjs, $store, $toast } = useNuxtApp();

        const job = computed(() => $store.getters['jobs/single/getSingleJob']);
        const isScheduledForPublication = computed(() => Boolean(job.value.publish_schedule));
        const isBursary = computed(() => job.value.job_type === 'Bursary');
        const defaultExpiryDays = computed(() => (isBursary.value ? 60 : 30));
        const formTitle = computed(() => (isBursary.value ? 'Bursary Publication Schedule' : 'Job Publication Schedule'));

        const errors = ref([]);
        const loading = ref(false);
        const minDate = $dayjs().format('YYYY-MM-DD');
        const maxDate = $dayjs().add(defaultExpiryDays.value, 'days').format('YYYY-MM-DD');

        const form = reactive({
            scheduled_date: job.value.publish_schedule?.scheduled_date,
            expiry_date: job.value.publish_schedule?.expiry_date,
            university_scope: null,
        });

        const rules = computed(() => ({
            scheduled_date: {
                required: helpers.withMessage('The scheduled date field is required.', required),
                minValue: helpers.withMessage('The scheduled date must be a date after the current date and time.', (value) =>
                    $dayjs(value).isAfter(new Date()),
                ),
            },
            expiry_date: {
                required: helpers.withMessage('The expiry date field is required.', required),
                minValue: helpers.withMessage('The expiry date must be a date after scheduled date.', (value) =>
                    $dayjs(value).isAfter(form.scheduled_date),
                ),
                maxValue: helpers.withMessage(`The expiry date must be within ${defaultExpiryDays.value} days of the scheduled date.`, (value) =>
                    $dayjs(form.scheduled_date).add(defaultExpiryDays.value, 'days').isAfter(value),
                ),
            },
            university_scope: {
                required: helpers.withMessage('The University Scope field is required.', required),
                $lazy: true,
            },
        }));

        const v$ = useVuelidate(rules, form);

        const submit = () => {
            v$.value.$validate();

            if (v$.value.$invalid) return;

            isScheduledForPublication.value ? updateSchedule() : createSchedule();
        };

        const createSchedule = async () => {
            loading.value = true;

            $store
                .dispatch('jobPublishSchedules/create', {
                    job_uuid: job.value.uuid,
                    scheduled_date: form.scheduled_date,
                    expiry_date: form.expiry_date,
                    university_scope: form.university_scope,
                })
                .then(() => {
                    closeWithMessage('Job publication scheduled.');
                })
                .catch((error) => {
                    errors.value = error.response.data.errors;
                })
                .finally(() => {
                    loading.value = false;
                });
        };

        const updateSchedule = async () => {
            loading.value = true;

            $store
                .dispatch('jobPublishSchedules/update', {
                    schedule_uuid: job.value.publish_schedule.uuid,
                    scheduled_date: form.scheduled_date,
                    expiry_date: form.expiry_date,
                })
                .then(() => {
                    closeWithMessage('Job publication schedule updated.');
                })
                .catch((error) => {
                    errors.value = error.response.data.errors;
                })
                .finally(() => {
                    loading.value = false;
                });
        };

        const closeWithMessage = (message) => {
            $toast.show({ type: 'success', message });

            v$.value.$reset();

            context.emit('close-modal');
        };

        return {
            errors,
            form,
            formTitle,
            isScheduledForPublication,
            job,
            loading,
            maxDate,
            minDate,
            submit,
            v$,
        };
    },
};
